"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { useEffect, useRef, useState } from "react";
import { ArrowLeft, ArrowRight, Star } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Testimonials() {
  const testimonials = [{
    quote: "They arrived exactly on time to clear our gutters and inspect the roof. Professional, efficient, and left the site spotless.",
    author: "Gerry Stevens",
    role: "Yacht Broker, Caley Marina",
    timestamp: "2 weeks ago",
    rating: 5,
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/client_sarah.png",
    avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/client_sarah.png-wvc-srcset",
    avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/client_sarah.png-wvc-sizes",
    workImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/gutter_cleaning_service.png",
    workSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/gutter_cleaning_service.png-wvc-srcset",
    workSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/gutter_cleaning_service.png-wvc-sizes"
  }, {
    quote: "Carried out all work efficiently with great attention to detail. Would recommend Matt and his services to anyone. Thanks again",
    author: "Kai Munro",
    role: "Homeowner",
    timestamp: "1 month ago",
    rating: 5,
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/client_michael.png",
    avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/client_michael.png-wvc-srcset",
    avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/client_michael.png-wvc-sizes",
    workImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/commercial_pressure_wash.png",
    workSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/commercial_pressure_wash.png-wvc-srcset",
    workSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/commercial_pressure_wash.png-wvc-sizes"
  }, {
    quote: "Reliable roof maintenance. They identified a small leak before it became a disaster. Highly recommend their expertise.",
    author: "David L.",
    role: "Homeowner",
    timestamp: "3 weeks ago",
    rating: 5,
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/client_david.png",
    avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/client_david.png-wvc-srcset",
    avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/client_david.png-wvc-sizes",
    workImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/roof_maintenance_check.png",
    workSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/roof_maintenance_check.png-wvc-srcset",
    workSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/roof_maintenance_check.png-wvc-sizes"
  }, {
    quote: "Transparent pricing and excellent communication. The team treated our property with great care during the repair.",
    author: "Elena R.",
    role: "Homeowner, Riverside",
    timestamp: "1 week ago",
    rating: 5,
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/client_elena.png",
    avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/client_elena.png-wvc-srcset",
    avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/client_elena.png-wvc-sizes",
    workImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/roof_repair_detail.png",
    workSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/roof_repair_detail.png-wvc-srcset",
    workSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/roof_repair_detail.png-wvc-sizes"
  }, {
    quote: "From the initial quote to the final inspection, the process was seamless. Very impressed with their attention to detail.",
    author: "Daniel K.",
    role: "Homeowner, Oakwood",
    timestamp: "5 days ago",
    rating: 5,
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/client_daniel.webp",
    avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/client_daniel.webp-wvc-srcset",
    avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/client_daniel.webp-wvc-sizes",
    workImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/roof_cleaning_finish.png",
    workSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/roof_cleaning_finish.png-wvc-srcset",
    workSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718201/img/roof_cleaning_finish.png-wvc-sizes"
  }];
  const [api, setApi] = useState<CarouselApi | null>(null);
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(testimonials.length);
  const pausedRef = useRef(false);
  const {
    ref: revealRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  useEffect(() => {
    if (!api) return;
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap());
    const onSelect = () => setCurrent(api.selectedScrollSnap());
    api.on("select", onSelect);
    api.on("reInit", onSelect);
    return () => {
      api.off("select", onSelect);
    };
  }, [api]);
  useEffect(() => {
    if (!api) return;
    const interval = setInterval(() => {
      if (!pausedRef.current) {
        if (api.canScrollNext()) api.scrollNext();else api.scrollTo(0);
      }
    }, 7000);
    return () => clearInterval(interval);
  }, [api]);
  const formatIndex = (n: number) => String(n + 1).padStart(2, "0");
  return <section data-section-id="867" id="what-our-clients-say" className="bg-background py-24 md:py-32" onMouseEnter={() => {
    pausedRef.current = true;
  }} onMouseLeave={() => {
    pausedRef.current = false;
  }}>
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div ref={revealRef} className={`flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="flex-1">
            <p className="font-mono text-xs uppercase tracking-widest text-muted-foreground mb-6">
              [ 02 — TESTIMONIALS ]
            </p>
            <h2 className="font-default text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-foreground max-w-2xl font-bold">
              Restoration,{" "}
              <em className="italic text-foreground/90">
                proven by results.
              </em>
            </h2>
          </div>

          <div className="flex items-center gap-6">
            <span className="font-mono text-xs text-muted-foreground tracking-wider">
              {formatIndex(current)} / {formatIndex(count - 1)}
            </span>
            <div className="flex items-center gap-3">
              <Button variant="outline" size="icon" onClick={() => api?.scrollPrev()} aria-label="Previous testimonial" className="rounded-lg border-border bg-transparent hover:bg-accent size-11">
                <ArrowLeft className="size-4" />
              </Button>
              <Button variant="outline" size="icon" onClick={() => api?.scrollNext()} aria-label="Next testimonial" className="rounded-lg border-border bg-transparent hover:bg-accent size-11">
                <ArrowRight className="size-4" />
              </Button>
            </div>
          </div>
        </div>

        <Carousel setApi={setApi} opts={{
        align: "start",
        loop: false
      }} className="w-full">
          <CarouselContent className="-ml-6">
            {testimonials.map((t, i) => <CarouselItem key={i} data-index={i} className="pl-6 basis-[90%] sm:basis-[75%] md:basis-[65%] lg:basis-[55%]">
                <article className="bg-card border border-border rounded-lg p-8 md:p-10 h-full flex flex-col shadow-md">
                  <div className="flex items-center justify-between mb-8">
                    <div className="flex items-center gap-1">
                      {Array.from({
                    length: t.rating
                  }).map((_, s) => <Star key={s} className="size-4 fill-primary text-primary" />)}
                    </div>
                    <span className="font-mono text-xs text-muted-foreground tracking-wide">
                      {t.timestamp}
                    </span>
                  </div>

                  <blockquote className="flex-1 mb-10">
                    <span className="font-default italic text-5xl leading-none mr-1 align-top text-primary" aria-hidden="true">
                      &ldquo;
                    </span>
                    <span className="font-default leading-snug text-foreground !text-base">
                      {t.quote}
                    </span>
                  </blockquote>

                  <div className="flex items-center justify-between gap-4 pt-6 border-t border-border">
                    <div className="flex items-center gap-4 min-w-0">
                      <SafeHydrate><Avatar className="size-14 rounded-lg shrink-0">
                        
                        <AvatarFallback className="rounded-lg bg-muted text-foreground font-default">
                          {t.author.charAt(0)}
                        </AvatarFallback>
                      </Avatar></SafeHydrate>
                      <div className="min-w-0">
                        <p className="font-default font-semibold text-foreground text-base truncate">
                          {t.author}
                        </p>
                        <p className="font-default text-sm text-muted-foreground truncate">
                          {t.role}
                        </p>
                      </div>
                    </div>

                    <div className="relative group/work shrink-0">
                      <div className="size-20 rounded-lg overflow-hidden border border-border">
                        <img src={t.workImage} data-wvc-srcset={t.workSrcset} data-wvc-sizes={t.workSizes} alt="Completed roof maintenance work" loading="lazy" decoding="async" className="w-full h-full object-cover" />
                      </div>
                      <div className="absolute inset-0 rounded-lg bg-foreground/75 opacity-0 group-hover/work:opacity-100 transition-opacity duration-300 flex items-center justify-center px-2">
                        <span className="font-mono text-[10px] uppercase tracking-wider text-background text-center leading-tight">
                          View project →
                        </span>
                      </div>
                    </div>
                  </div>
                </article>
              </CarouselItem>)}
          </CarouselContent>
        </Carousel>

        <div className="flex items-center justify-center gap-2 mt-12">
          {Array.from({
          length: count
        }).map((_, i) => <Button key={i} data-index={i} onClick={() => api?.scrollTo(i)} aria-label={`Go to testimonial ${i + 1}`} variant="ghost" size="sm" className={`transition-all duration-300 rounded-lg px-0 h-auto ${current === i ? "w-8 h-1.5 bg-foreground" : "w-1.5 h-1.5 bg-muted-foreground/40 hover:bg-muted-foreground/70"}`} />)}
        </div>
      </div>
    </section>;
}